export default "__VITE_ASSET__Cxl9KmCe__"